export const COUNTRY_CODES = [
    "A1",
    "AE",
    "AG",
    "AN",
    "AP",
    "BA",
    "BL",
    "BN",
    "BO",
    "BQ",
    "BS",
    "CC",
    "CD",
    "CF",
    "CG",
    "CI",
    "CK",
    "CV",
    "DO",
    "EU",
    "FK",
    "FM",
    "FO",
    "FX",
    "GB",
    "GM",
    "IO",
    "IR",
    "KM",
    "KN",
    "KP",
    "KR",
    "KY",
    "LA",
    "LC",
    "MD",
    "MF",
    "MH",
    "MK",
    "MM",
    "MO",
    "MP",
    "NE",
    "NL",
    "O1",
    "PH",
    "PM",
    "PS",
    "RU",
    "SD",
    "SH",
    "SJ",
    "ST",
    "SX",
    "SY",
    "SZ",
    "TC",
    "TR",
    "TT",
    "TW",
    "TZ",
    "US",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "WF",
    "XK",
    "AF",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BW",
    "BV",
    "BR",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "TD",
    "CL",
    "CN",
    "CX",
    "CO",
    "CR",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KW",
    "KG",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "NA",
    "NR",
    "NP",
    "NC",
    "NZ",
    "NI",
    "NG",
    "NU",
    "NF",
    "NO",
    "OM",
    "PK",
    "PW",
    "PA",
    "PG",
    "PY",
    "PE",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RO",
    "RW",
    "RE",
    "WS",
    "SM",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SR",
    "SE",
    "CH",
    "TJ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TN",
    "TM",
    "TV",
    "UG",
    "UA",
    "UM",
    "UY",
    "UZ",
    "VU",
    "EH",
    "YE",
    "ZM",
    "ZW",
    "AX",
];
